import React, {useEffect, useState} from 'react';
import PropTypes from "prop-types";
import GuestFile from "../components/guest";
import {refreshToken} from "../../../api/login/api";
import {createSearchParams, useParams} from "react-router-dom";
import {DP_File} from "@datpd/demo-lib/dist/cjs";
import {Affix, Button, Space} from "antd";


let CryptoJS = require("crypto-js");


const DG_Editor_File = props => {

    const [accessToken, setAccessToken] = useState()
    const [refreshTokenKey, setRefreshTokenKey] = useState()
    const [showLogo, setShowLogo] = useState(false)

    const {planText} = useParams()


    useEffect(() => {

        if (planText) {
            setShowLogo(true)
            const decodeDocToken = JSON.parse(atob(planText))

            if (decodeDocToken?.mode !== "guest") {
                refreshToken().then((response) => {
                    const data = response.data;
                    setAccessToken(data.accessToken)
                    setRefreshTokenKey(data.refreshToken)
                })
            } else {
                setAccessToken(true)
            }
        } else {
            refreshToken().then((response) => {
                const data = response.data;
                setAccessToken(data.accessToken)
                setRefreshTokenKey(data.refreshToken)
            })
        }
    }, [])


    const getResult = () => {
        let action = props.action || "edit"
        let docFileApi = process.env.REACT_APP_DOC_FILE_API
        let baseUrl = process.env.REACT_APP_MY_API_KEY
        let fileId = props?.fileId
        if (window.location.pathname?.includes("/file")) {


            const pathname = window.location.pathname
            const docToken = pathname.substring("/file/".length, pathname.length)
            const decodeDocToken = JSON.parse(atob(docToken))

            fileId = decodeDocToken.fileId

            if (decodeDocToken?.mode === "guest")
                return <GuestFile
                    fileId={decodeDocToken.fileId}
                    docToken={docToken}
                />
            if (decodeDocToken?.mode) {
                action = decodeDocToken?.mode
            }
        }

        const object = {
            "dogoo-x-user-context-request": accessToken,
            "baseUrl": baseUrl,
            "fileId": fileId,
            "type": "desktop",
            "action": action,
            "refreshToken": refreshTokenKey
        }

        const searchParams = createSearchParams({
            planText: CryptoJS.AES.encrypt(JSON.stringify(object), "Dogoo@2022")
        })

        return <DP_File
            {...props}
            docFileApi={docFileApi}
            searchParams={searchParams.toString()}
        />
    }

    const getLogo = () => {
        return <Space>
            <img
                src={process.env.PUBLIC_URL + "/logo/favicon-32x32.png"}
                height={"20px"}
            />
            Dogoo
        </Space>
    }

    return (
        <>
            {showLogo && <Affix offsetTop={0} style={{width: "0px", height: "0px"}}>

                <Button type="text" style={{
                    height: "28px", width: "122px",
                    background: "#446995",
                    color: "white",
                    fontFamily: "Arial,Helvetica,\"Helvetica Neue\",sans-serif"
                }}
                >

                    {getLogo()}
                </Button>
            </Affix>}
            {accessToken && getResult()}
        </>
    );
};

DG_Editor_File.propTypes = {
    fileId: PropTypes.string,

};

export default DG_Editor_File;
